import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useGlobalContext } from "../../context";
import { getViewPort } from "@/utils";
import { NavigationMenu, NavigationMenuItem, NavigationMenuList } from "@/components/ui/navigation-menu";

const navigationItems = [
  { path: "/", label: "navbar.home", dataSection: "" },
  { path: "/about-us", label: "navbar.about", dataSection: "about-us" },
  { path: "/experience", label: "navbar.experience", dataSection: "experience", desktopOnly: true },
  { path: "/blogs", label: "navbar.blogs", dataSection: "blogs", desktopOnly: true },
  { path: "/portfolio", label: "navbar.porfolio", dataSection: "portfolio" },
  { path: "/skills", label: "navbar.skills", dataSection: "skills" },
  { path: "/contact", label: "navbar.Contact", dataSection: "contact" },
];

export const NavMenu = ({ show, toggleMenu, containerRef, theme }) => {
  const { t } = useGlobalContext();
  const [device, setDevice] = useState("");
  const location = useLocation();

  useEffect(() => {
    const changeState = () => setDevice(getViewPort());
    changeState();

    window.addEventListener("resize", changeState);
    return () => window.removeEventListener("resize", changeState);
  }, []);

  const isActive = (path) => {
    return location.pathname === path ? "bg-accent text-accent-foreground" : "";
  };

  return (
    <NavigationMenu
      ref={containerRef}
      className="max-w-none hidden md:block"
    >
      <NavigationMenuList className="space-x-2">
        {navigationItems.map((item) => {
          if (item.desktopOnly && device !== "DESKTOP") return null;
          
          return (
            <NavigationMenuItem 
              key={item.path}
              data-section={item.dataSection} 
              onClick={() => (show ? toggleMenu() : null)}
            >
              <Link 
                to={item.path} 
                className={`${theme} block select-none rounded-md px-3 py-2 text-sm font-medium hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground ${isActive(item.path)}`}
              >
                {t(item.label)}
              </Link>
            </NavigationMenuItem>
          );
        })}
      </NavigationMenuList>
    </NavigationMenu>
  );
}; 